// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from 'lodash';

const styles = ({ padding, margin, color }) => ({
  outerContainer: {
    color: get(color, 'bodyText'),
    padding: '48px',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: 'column',
    gap: get(padding, 'p24'),
    alignSelf: "flex-start",
  },
  contentContainer: {
    backgroundColor: get(color, 'white'),
    border: `1px solid ${color.grayBorder}`,
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    padding: '36px 48px',
    width: '424px',
    gap: get(padding, 'p24'),
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: get(padding, 'p12'),
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      height: '100px',
    },
    '& $alternateLogo': {
      width: '67px',
      lineHeight: '67px',
      fontSize: '34px',
      fontWeight: 400,
    },
  },
  alternateLogo: {
    margin: 0,
    backgroundColor: get(color, 'iconsMain'),
    borderRadius: '50%',
    color: get(color, 'white'),
    alignSelf: 'center',
    fontSize: '16px',
    fontWeight: 600,
    width: '36px',
    lineHeight: '36px',
    padding: '2px',
  },
  aHubHeaderText: {
    margin: 0,
    paddingTop: 40,
    textAlign: 'center',
  },
  headerText: {
    margin: 0,
    textAlign: 'center',
  },
  descriptionText: {
    margin: 0,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  authSchemesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: get(padding, 'p12'),
  },
  or: {
    margin: 0,
  },
  buttonStyles: {
    height: "auto",
    padding: "4px 8px 4px 12px",
    '&:focus': {
      outlineOffset: "1px",
      outline: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
  buttonContent: {
    lineHeight: '14px',
    fontWeight: 600,
    minHeight: '14px',
    flexGrow: 1,
    padding: "9px 8px",
    marginRight: get(margin, 'm36'),
  },
  buttonIcon: {
    width: get(padding, 'p24'),
    height: get(padding, 'p24'),
  },
});

export default styles;